import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-product-review-modal',
    templateUrl: './product-review-modal.component.html',
    styles: [],
})
export class ProductReviewModalComponent implements OnInit {
    constructor(public activeModal: NgbActiveModal) {}

    review: any;

    ngOnInit(): void {}
}
